import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

import EmailLogIn from './EmailLogIn';
import Footer from './Footer';
import PasswordSet from './PasswordSet';
import Register from './Register';
import Registered from './Registered';
import ResetPassword from './ResetPassword';
import SetPassword from './SetPassword';
import SignIn from './SignIn';
import Verified from './Verified';
import VerifyEmail from './VerifyEmail';
import Welcome from './Welcome';

const base = process.env.PUBLIC_URL;
const supportsHistory = 'pushState' in window.history;

function Routes() {
  return (
    <Router basename={base} forceRefresh={!supportsHistory}>
      <article>
        <Switch>
          <Route path="/signin" component={SignIn} />
          <Route path="/login" component={EmailLogIn} />
          <Route path="/signup" component={Register} />
          <Route path="/verify" component={VerifyEmail} />
          <Route path="/verified" component={Verified} />
          <Route path="/reset" component={ResetPassword} />
          <Route path="/password" component={SetPassword} />
          <Route path="/set" component={PasswordSet} />
          <Route path="/registered" component={Registered} />
          <Route path="/welcome" component={Welcome} />
          <Route path="/">
            <Redirect to="/signin" />
          </Route>
        </Switch>
      </article>
      <Footer />
    </Router >
  );
}

export default Routes;
